import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Expired from './Expired';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'leaflet/dist/leaflet.css';
import 'toastr/build/toastr.min.css';
import './css/leaflet.awesome-markers.css'
import './index.css';
import './css/animate.css';
import './css/style.css';
import './css/font-awesome.min.css';
import './css/App.css';
import './css/breadcrumb.css';

//import registerServiceWorker from './registerServiceWorker';

var cryjs = require("crypto-js");

ReactDOM.render(<App />, document.getElementById('root'));


//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js